/* lua.js generated code 0.3.0 */

require("clover/panel/base/BasePanel")
require("clover/panel/component/common/uiGroupButtonLayout/UIGLabelButton")
require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")

const TEXT_HEIGHT_LIMIT = 464;  // 文本最大高度，超出使用滚动框

let Panel = xClass("CompenPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/compen_panel_panel.csb")
})
Panel.show = function (config, callback, onSuccess, onFail, onCancel) {
    function success() {
        let panel = Panel.create(config, callback)
        if (onSuccess) {
            onSuccess(panel)
        }else {
            panel.popup(true)
        }
    }
    preloadWithLoading(["packed/CompenPanelRes.pack"], success, onFail, onCancel)
}
Panel.prototype.ctor = function (config, callback) {
    let self = this
    self.callback = callback
    self.itemSetting = table()
    self.isBusy = false
    BasePanel.prototype.ctor.call(self)
    self.buildUI(config)
    self.config = config
}
Panel.prototype.buildUI = function (config) {
    let self = this

    let close = self.getChildByName("btn_close")
    close.setAnchorPoint(0.25, 0.25)
    close.setPosition(close.x + 20, close.y + 20)
    UIButton.create(close)
    close.on(UIButtonEvent.Click, function () {
        Localhost.addShowedCompenList(config.id)
        self.onClose()
    })

    let bg = self.getChildByName("bg")
    let bgSize = bg.getContentSize()
    let totalHeight = 0

    let title = self.getChildByName("title")
    // let newTitle = cc.Label.createWithSystemFont(getText(config.compenTitle || getText("compen.panel.title")), "Arial", 60)
    let newTitle = cc.LabelBMFont.create(getText(config.compenTitle || getText("compen.panel.title")), "font/zzgftongxin_70_brownstroke.fnt")
    newTitle.setAnchorPoint(0.5, 1)
    let contentSize = newTitle.getContentSize()
    newTitle.setScale(0.75)
    newTitle.setPosition(bgSize.width/ 2, -40)
    title.removeFromParent(true)
    self.addChild(newTitle)
    totalHeight = -title.getPositionY() + contentSize.height

    let imagebg = self.getChildByName("image_bg")
    imagebg.setPositionY(imagebg.getPositionY() - 5)
    let image = self.getChildByName("image")
    let size = image.getContentSize()
    if (type(config.imageUrl) === "string" && string.len(config.imageUrl) > 0) {
        let texture = cc.textureCache.addImage(config.imageUrl)
        image.setTexture(texture)
    }
    image.setPositionY(image.getPositionY() - 5)
    // totalHeight = -image.getPositionY() + 10
    totalHeight = totalHeight + size.height + 30

    let text = self.getChildByName("text")
    let newText = cc.Label.createWithSystemFont("", "Arial", 25)
    let margin_left = 50
    newText.setDimensions(bgSize.width - 2*margin_left, 0)    
    // QQlightGame上文本需要在setDimensions后设置，否则可能会有重叠
    newText.setString(config.compenText || getText("compen.panel.text", table([1, "n", "\n"])))
    contentSize = newText.getContentSize()
    // newText.setPosition(287, -totalHeight)
    newText.setPosition(margin_left, -totalHeight)
    newText.setTextColor(text.getTextColor())
    newText.setAnchorPoint(text.getAnchorPoint())
    text.removeFromParent(true)
    if (contentSize.height > TEXT_HEIGHT_LIMIT) {
        let scrollView = ccui.ScrollView.create()
        scrollView.setDirection(ccui.ScrollViewDir.vertical)
        scrollView.setContentSize(contentSize.width, TEXT_HEIGHT_LIMIT);
        scrollView.setAnchorPoint(newText.getAnchorPoint().x, newText.getAnchorPoint().y);
        scrollView.setPosition(newText.x, newText.y);
        scrollView.setClippingEnabled(true)
        scrollView.setBounceEnabled(true);
        scrollView.setInnerContainerSize(cc.size(contentSize.width, contentSize.height))
        self.addChild(scrollView);
        newText.setAnchorPoint(0, 0)
        newText.setPosition(0, 0);
        scrollView.addChild(newText);
    } else {
        self.addChild(newText)
    }
    totalHeight = totalHeight + Math.min(TEXT_HEIGHT_LIMIT,  contentSize.height)
    // contentSize = text.getContentSize()
    // // size = text.getVirtualRendererSize()
    // text.setPosition(cc.p((bgSize.width - contentSize.width) / 2, -totalHeight - 20))
    // // text.getVirtualRenderer().setDimensions(bgSize.width - 100, 0)
    // text.setString(tostring(config.compenText || getText("compen.panel.text", table([1, "n", "\n"]))))
    // text.setContentSize(500, contentSize.height)
    // let image = self.getChildByName("image")
    // let size = image.getContentSize()
    // image.setPositionY(-totalHeight - 20 - size.height / 2)
    // if (type(config.imageUrl) === "string" && string.len(config.imageUrl) > 0) {
    //     if (config.imageUrl === "nil" || config.imageUrl === "null") {
    //         image.removeFromParent(true)
    //     } else {
    //         HeadImageLoader.loadImage(image, config.imageUrl, null, true)
    //         totalHeight = totalHeight + size.height + 20
    //     }
    // } else {
    //     totalHeight = totalHeight + size.height + 20
    // }
    let rwItemCfg = table()
    config.rewards = config.rewards || table()
    let [tC, line] = [$len(config.rewards), Math.ceil($len(config.rewards) / 4)]
    let $limit19 = line
    for (let i = 1; i <= $limit19; i += 1) {
        let count = Math.ceil(tC / line)
        table.insert(rwItemCfg, count)
        ;[tC, line] = [tC - count, line - 1]
    }
    let [curLine, cInLine] = [1, 1]
    let sizeRec = null
    for (let i = 1, v = (config.rewards || table())[1]; v; i++, v = (config.rewards || table())[i]) {
        let item = self.createRewardItem(v)
        let size = item.getContentSize()
        if (!sizeRec) {
            sizeRec = size
        }
        let count = rwItemCfg[curLine]
        let pos = cc.p((bgSize.width - count * size.width - (count - 1) * 10) / 2 + (cInLine - 1) * size.width + (cInLine - 2) * 10 + 6, -totalHeight - curLine * 10 - (curLine - 1) * size.height - 15)
        // let bg = item.getChildByName("bg")
        // bg.removeFromParent(true)
        // bg.setPosition(cc.p(bg.getPositionX() + pos.x, bg.getPositionY() + pos.y))
        // self.addChild(bg)
        // let icon = item.getChildByName("icon")
        // icon.removeFromParent(true)
        // icon.setPosition(cc.p(icon.getPositionX() + pos.x, icon.getPositionY() + pos.y))
        // self.addChild(icon, 5)
        // let num = item.getChildByName("num")
        // num.removeFromParent(true)
        // num.setPosition(cc.p(num.getPositionX() + pos.x, num.getPositionY() + pos.y))
        // self.addChild(num, 10)
        self.addChild(item, 10)
        item.getChildByName("num").setLocalZOrder(9999)
        item.getChildByName("num").setNextFontPositionXOffset(5);
        item.setPosition(cc.p(item.getPositionX() + pos.x, item.getPositionY() + pos.y))
        table.insert(self.itemSetting, table(
            [1, "itemId", v.itemId],
            [1, "num", v.num],
            [1, "icon", item]
            // [1, "numTxt", num]
        ))
        cInLine = cInLine + 1
        if (cInLine > rwItemCfg[curLine]) {
            curLine = curLine + 1
            cInLine = 1
        }
    }
    if (sizeRec) {
        totalHeight = totalHeight + $len(rwItemCfg) * (10 + sizeRec.height) + 15
    }
    let btn = UIGLabelButton.create(self.getChildByName("btn"))
    if ($len((config.rewards || table())) > 0) {
        btn.setString(tostring(config.compenBtn || getText("compen.panel.btn")))
    } else {
        btn.setString(tostring(config.compenBtn || getText("compen.panel.btn2")))
    }
    btn.setScale(0.8)
    PushBounceIdleBubbleAnim.create(btn)
    size = btn.getContentSize()
    size = cc.size(size.width * btn.getScaleX(), size.height * btn.getScaleY())
    btn.setPositionY(-totalHeight - size.height / 2 - 10)
    totalHeight = totalHeight + size.height + 10
    btn.on(UIButtonEvent.Click, function () {
        self.getRewards(config)
    })
    bg.setContentSize(cc.size(bgSize.width, totalHeight + 50))
    self.setContentSize(bg.getContentSize())
    self.setScale(self.getReferenceScale())
}
Panel.prototype.createRewardItem = function (config) {
    let self = this
    let item = cc.CSLoader.createNode("cocos/compen_panel_rw_item.csb")
    let bg = item.getChildByName("bg")
    bg.setScale9Enabled(true)
    let bgSize = bg.getContentSize()
    let icon = item.getChildByName("icon")
    let iSize = icon.getContentSize()
    iSize = cc.size(iSize.width * icon.getScaleX(), iSize.height * icon.getScaleY())
    let sprite = UIItemBuilder.createPropIcon(config.itemId)
    let size = sprite.getContentSize()
    sprite.setScale(iSize.width / size.width)
    sprite.setPosition(cc.p(icon.getPosition()))
    sprite.setName("icon")
    item.addChild(sprite)
    icon.removeFromParent(true)
    let num = item.getChildByName("num")
    let scale = num.getScale()
    num.getVirtualRenderer().setAdditionalKerning(-6)
    num.setString("x" + tostring(config.num))
    size = num.getContentSize()
    num.setPositionX(bgSize.width - size.width * num.getScale() - 10)
    num.y -= 12
    num.x += 10
    return item
}
Panel.prototype.getRewards = function (config) {
    let self = this
    if (self.isBusy) {
        return 
    }
    self.isBusy = true
    function recordCompen(isSuccess) {
        let list = UserManager.getInstance().compenList
        if (config.type === CompenType.compen && isSuccess) {
            table.removeIfExist(list, config)
        }
        Localhost.addShowedCompenList(config.id)
    }
    function onSuccess() {
        for (let i = 1, v = (config.rewards || table())[1]; v; i++, v = (config.rewards || table())[i]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num)
        }
        recordCompen(true)
        UserManager.getInstance().flushUserData()
        self.playRewardAnim(function () {
            self.onClose()
        })
    }
    function onFail(evt) {
        recordCompen(false)
        Toast.make(getText("error.tip." + tostring(evt.data)), null, function () {
            self.isBusy = false
            self.onClose()
        })
    }
    function onCancel() {
        self.isBusy = false
    }

    if (config.type !== CompenType.compen) {
        recordCompen(false)
        self.onClose()
        return
    }

    let http = GetCompenRewardHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(config.id)
}
Panel.prototype.playRewardAnim = function (callback) {
    let self = this
    let flyItemOps = table()
    for (let i = 1, v = (self.itemSetting || table())[1]; v; i++, v = (self.itemSetting || table())[i]) {
        let parent = v.icon.getParent()
        let pos = parent.convertToWorldSpace(cc.p(v.icon.getPosition()))
        table.insert(flyItemOps, table(
            [1, "itemId", v.itemId],
            [1, "num", v.num],
            [1, "pos", pos],
            [1, "scale", v.icon.getScale()]
        ))
        v.icon.setVisible(false)
        // v.numTxt.setVisible(false)
    }
    if ($len(flyItemOps) <= 0) {
        callback()
    }
    HomeSceneAnimation.playGetPropAnimation(flyItemOps, callback, 0.15)
}
Panel.prototype.remove = function (cleanup, callback) {
    let self = this
    BasePanel.prototype.remove.call(self, cleanup, function () {
        if (self.callback) {
            self.callback()
        }
        if (callback) {
            callback()
        }
    })
}
Panel.prototype.onCleanup = function () {
    ResManager.release(["packed/CompenPanelRes.pack"])
}
Panel.prototype.onKeyBackClicked = function () { }
module.exports = Panel
